import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL; 

export const getSquads = async () => {
  const response = await axios.get(`${API_URL}division`, { headers: getHeaders() });
  return response.data;
};

export const storeSquad = async (squad) => {
  const isMultipart = typeof FormData !== 'undefined' && squad instanceof FormData;
  const response = await axios.post(`${API_URL}division`, squad, { headers: getHeaders(isMultipart) });
  return response.data;
};

export const getDetailSquad = async (id) => {
  const response = await axios.get(`${API_URL}division/${id}`, { headers: getHeaders() });
  return response.data;
};

export const deleteSquad = async (id) => {
  const response = await axios.delete(`${API_URL}division/${id}`, { headers: getHeaders() });
  return response.data;
};

export const updateSquad = async (id, data) => {
  const isMultipart = typeof FormData !== 'undefined' && data instanceof FormData;
  if (isMultipart) {
    if (!data.has('_method')) {
      data.append('_method', 'PUT');
    }
    const response = await axios.post(`${API_URL}division/${id}`, data, { headers: getHeaders(true) });
    return response.data;
  }
  const response = await axios.put(`${API_URL}division/${id}`, data, { headers: getHeaders(false) });
  return response.data;
};
